module.exports = __webpack_public_path__ + "media/assets/services_manager/arrow-down-62ff725153505dd3385169e4771f8d27ffb2ae346a5098a5c8a65020980f5cab.svg";